import Table from './table';
import { styled, keyframes } from '@mui/material/styles';

const translate = keyframes`
  from {
    transform: translateY(-50%);
    opacity: 0;
  }
  to {
    transform: translateY(0%);
    opacity: 1;
  }
`;

export const TableStyled = styled(Table)<{ animated?: boolean }>(
  ({ animated }) => ({
    aninmated: true,
    '&.MuiTable-root': {
      backgroundColor: 'rgba(255,255,255,0.5)',
    },

    '& .MuiTableRow-root:not(.MuiTableRow-head)': {
      opacity: animated === true ? 0 : 1,
      animation: animated === true ? `${translate} 0.4s forwards` : '',
      animationIterationCount: 1,
    },
    '& .MuiTableRow-root:nth-of-type(1)': {
      animationDelay: '0.02s',
    },
    '& .MuiTableRow-root:nth-of-type(2)': {
      animationDelay: '0.04s',
    },
    '& .MuiTableRow-root:nth-of-type(3)': {
      animationDelay: '0.06s',
    },
    '& .MuiTableRow-root:nth-of-type(4)': {
      animationDelay: '0.08s',
    },
    '& .MuiTableRow-root:nth-of-type(5)': {
      animationDelay: '0.1s',
    },
    '& .MuiTableRow-root:nth-of-type(6)': {
      animationDelay: '0.12s',
    },
    '& .MuiTableRow-root:nth-of-type(7)': {
      animationDelay: '0.14s',
    },
    '& .MuiTableRow-root:nth-of-type(8)': {
      animationDelay: '0.16s',
    },
    '& .MuiTableRow-root:nth-of-type(9)': {
      animationDelay: '0.18s',
    },
    '& .MuiTableRow-root:nth-of-type(10)': {
      animationDelay: '0.2s',
    },
    '& .MuiTableRow-root:nth-of-type(11)': {
      animationDelay: '0.22s',
    },
    '& .MuiTableRow-root:nth-of-type(12)': {
      animationDelay: '0.24s',
    },
    '& .MuiTableRow-root:nth-of-type(13)': {
      animationDelay: '0.26s',
    },
    '& .MuiTableRow-root:nth-of-type(14)': {
      animationDelay: '0.28s',
    },
    '& .MuiTableRow-root:nth-of-type(15)': {
      animationDelay: '0.3s',
    },
    '& .MuiTableRow-root:nth-of-type(16)': {
      animationDelay: '0.32s',
    },
    '& .MuiTableRow-root:nth-of-type(17)': {
      animationDelay: '0.34s',
    },
    '& .MuiTableRow-root:nth-of-type(18)': {
      animationDelay: '0.36s',
    },
    '& .MuiTableRow-root:nth-of-type(19)': {
      animationDelay: '0.38s',
    },
    '& .MuiTableRow-root:nth-of-type(20)': {
      animationDelay: '0.4s',
    },
  })
);

export default TableStyled;
